"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var DetailDataSingleLabel_1 = __importDefault(require("../contract_form/DetailDataSingleLabel"));
var date_parser_1 = __importDefault(require("../../../common/src/utils/date/date_parser"));
var SalesForceButtonArea_1 = __importDefault(require("./SalesForceButtonArea"));
var DatePickerWrapper_1 = __importDefault(require("../datepicker/DatePickerWrapper"));
var value_checker_1 = __importDefault(require("../../../common/src/utils/validation/value_checker"));
var ReflectType_1 = require("../../../common/src/types/sales_force/ReflectType");
var MoveSalesForceButton_1 = __importDefault(require("./MoveSalesForceButton"));
var SimpleDialog_1 = __importDefault(require("../globals/SimpleDialog"));
var PriceBookSelect_1 = __importDefault(require("./PriceBookSelect"));
var ProductSelect_1 = __importDefault(require("./ProductSelect"));
var object_utils_1 = __importDefault(require("../../../common/src/utils/sales_force/object_utils"));
var contract_finish_1 = require("../../utils/mail/template/contract_finish");
var OpportunityProfessional = /** @class */ (function (_super) {
    __extends(OpportunityProfessional, _super);
    function OpportunityProfessional() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {};
        _this.showAlertDialog = false;
        _this.alertMessage = '';
        _this.showConfirmDialog = false;
        _this.confirmMessage = '';
        _this.salesForceInfo = {
            torihikisakiId: '',
            opportunityId: '',
            professionalPrice: '',
            professionalContractState: '',
            professionalRequestStartDate: null,
            professionalContractEdate: null,
            professionalItPeriod: '',
            professionalBunkatuFlg: '',
            professionalItFlg: '',
            professionalTokubetuFlg: '',
            professionalTokubetuDetail: '',
            opportunityProfessionalId: '',
            opportunityProfessionalName: '',
            professionalContractStartDate: null,
            professionalPriceBook2Id: '',
            professionalProductId: '',
            opportunityProfessionalItemId: '',
            professionalPriceBook2Name: '',
            professionalPriceBook2Description: '',
            professionalProductName: '',
            professionalPriceDefault: '',
            professionalPriceBookMonth: '',
            professionalPriceBookData: [],
            professionalProductPlanName: '',
            professionalCancelFlag: '',
            professionalPrimaryAssignedIdFlg: ''
        };
        _this.professionalPrice = '';
        _this.professionalItFlgDisabled = false;
        _this.professionalItFlgDescription = false;
        return _this;
    }
    OpportunityProfessional.prototype.professionalPriceChange = function (newPrice) {
        this.professionalPrice = String(newPrice);
        this.salesForceInfo.professionalPrice = this.professionalPrice;
    };
    OpportunityProfessional.prototype.getPlanName = function () {
        return contract_finish_1.ContractCompleteMailTemplate.getProfessionalPlanName(this.form, this.salesForceInfo);
    };
    OpportunityProfessional.prototype.reCorrect = function () {
        this.$emit('re-correct');
    };
    OpportunityProfessional.prototype.periodChange = function () {
        var sdate = this.form.applyInfoProfessionalStartDate;
        this.salesForceInfo.professionalContractStartDate = sdate;
        this.salesForceInfo.professionalRequestStartDate = object_utils_1.default.getSdateNextContract(this.salesForceInfo.professionalContractStartDate, '1');
        if (this.salesForceInfo.professionalPriceBookMonth === '1' && this.salesForceInfo.professionalProductPlanName === '月間') {
            this.salesForceInfo.professionalContractEdate = '';
        }
        else {
            this.salesForceInfo.professionalContractEdate = object_utils_1.default.getEdateFromSdate(this.salesForceInfo.professionalContractStartDate, this.salesForceInfo.professionalPriceBookMonth);
        }
    };
    OpportunityProfessional.prototype.refs = function () {
        return this.$refs;
    };
    OpportunityProfessional.prototype.getTranslation = function (key) {
        return this.$t(key);
    };
    OpportunityProfessional.prototype.parseDate = function (dateStr) {
        return date_parser_1.default.toJapaneseDateStr(dateStr);
    };
    OpportunityProfessional.prototype.mounted = function () {
        this.initDataChange();
        this.initSalesForceDataChange();
    };
    OpportunityProfessional.prototype.salesForceAutoComplete = function () {
        if (value_checker_1.default.isBlank(this.salesForceInfo.professionalContractStartDate)) {
            this.salesForceInfo.professionalContractStartDate = this.form['applyInfoProfessionalStartDate'];
        }
        if (value_checker_1.default.isBlank(this.salesForceInfo.opportunityProfessionalName)) {
            this.salesForceInfo.opportunityProfessionalName = this.form.officeInfoOfficeName + "_" + date_parser_1.default.toString(new Date());
        }
        if (value_checker_1.default.isPresent(this.salesForceInfo.opportunityId) && value_checker_1.default.isBlank(this.salesForceInfo.opportunityProfessionalId)) {
            if (value_checker_1.default.isPresent(this.salesForceInfo.professionalPrimaryAssignedIdFlg)) {
                this.salesForceInfo.opportunityProfessionalId = this.salesForceInfo.opportunityId;
            }
        }
        // IT補助金対応商品選択時
        // if (ValueChecker.isPresent(this.salesForceInfo.professionalProductPlanName) && this.salesForceInfo.professionalProductPlanName === '2年') {
        //     this.salesForceInfo.professionalItFlg = 'true';
        //     this.professionalItFlgDisabled = true;
        //     this.professionalItFlgDescription = true;
        // }
        this.periodChange();
    };
    OpportunityProfessional.prototype.initDataChange = function () {
        this.form = this.initData;
        this.salesForceAutoComplete();
    };
    OpportunityProfessional.prototype.productChange = function (newProductInfo) {
        this.salesForceInfo.professionalProductName = newProductInfo['name'];
        this.salesForceInfo.professionalProductPlanName = newProductInfo['planName'];
        this.salesForceInfo.professionalPriceBookMonth = newProductInfo['month'];
        // IT補助金対応商品選択時
        // if (this.salesForceInfo.professionalProductPlanName === '2年') {
        //     this.salesForceInfo.professionalItFlg = 'true';
        //     this.professionalItFlgDisabled = true;
        //     this.professionalItFlgDescription = true;
        // } else {
        //     this.salesForceInfo.professionalItFlg = null;
        //     this.professionalItFlgDisabled = false;
        //     this.professionalItFlgDescription = false;
        // }
        this.periodChange();
    };
    OpportunityProfessional.prototype.professionalChange = function (newProductItems) {
        this.salesForceInfo.professionalPriceBookData = newProductItems;
    };
    OpportunityProfessional.prototype.getSalesForcePeriod = function () {
        return object_utils_1.default.getSalesForcePeriod(this.form.applyInfoProfessionalPeriod);
    };
    OpportunityProfessional.prototype.initSalesForceDataChange = function () {
        this.salesForceInfo = this.initSalesForceData;
        this.salesForceAutoComplete();
    };
    OpportunityProfessional.prototype.submit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var self_, errorMessage;
            return __generator(this, function (_a) {
                self_ = this;
                event.preventDefault();
                if (value_checker_1.default.isBlank(self_.salesForceInfo.torihikisakiId)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_torihikisaki_id').toString();
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(self_.salesForceInfo.professionalPriceBook2Id)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_pricebook_id').toString();
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(String(self_.salesForceInfo.professionalProductId))) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_product_id').toString();
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(String(self_.salesForceInfo.professionalPrice))) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_price').toString();
                    return [2 /*return*/];
                }
                if (this.isPriceDifferent() && this.isTokubetuBlank()) {
                    errorMessage = "<div class=\"col\">" +
                        this.$t('view.sales_force.reflect.msg.price_error') +
                        ("<br>\u6A19\u6E96\u4FA1\u683C: <strong>" + this.professionalPrice + "</strong><br>") +
                        ("\u8CA9\u58F2\u4FA1\u683C: <strong>" + this.salesForceInfo.professionalPrice + "</strong><br>");
                    this.showAlertDialog = true;
                    this.alertMessage = errorMessage;
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isPresent(self_.salesForceInfo.professionalBunkatuFlg) && this.isTokubetuBlank()) {
                    this.showAlertDialog = true;
                    this.alertMessage = String(this.$t('view.sales_force.reflect.msg.bunkatu_error'));
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isPresent(self_.salesForceInfo.opportunityProfessionalId)) {
                    this.confirmMessage = '商談・商談商品オブジェクト（Rehab Cloud Pro）を<strong>更新</strong>します。よろしいですか？';
                }
                else {
                    this.confirmMessage = '商談・商談商品オブジェクト（Rehab Cloud Pro）を<strong>新規に追加</strong>します。よろしいですか？';
                }
                this.showConfirmDialog = true;
                return [2 /*return*/];
            });
        });
    };
    OpportunityProfessional.prototype.dialogClose = function () {
        this.showConfirmDialog = false;
        this.showAlertDialog = false;
    };
    OpportunityProfessional.prototype.reflect = function () {
        var self_ = this;
        self_.dialogClose();
        this.$emit('reflect', this.getAjaxInfo());
    };
    OpportunityProfessional.prototype.getPriceErrorMsg = function () {
        if (this.isPriceDifferent()) {
            return this.$t('view.sales_force.reflect.msg.price_warning');
        }
        return '';
    };
    OpportunityProfessional.prototype.isPriceDifferent = function () {
        return String(this.professionalPrice) !== String(this.salesForceInfo.professionalPrice);
    };
    OpportunityProfessional.prototype.isTokubetuBlank = function () {
        return value_checker_1.default.isBlank(this.salesForceInfo.professionalTokubetuDetail);
    };
    OpportunityProfessional.prototype.getAjaxInfo = function () {
        // カラム追加した項目は、NullCareをしないと、trim()でエラー
        if (!this.salesForceInfo.opportunityProfessionalItemId) {
            this.salesForceInfo.opportunityProfessionalItemId = '';
        }
        if (!this.salesForceInfo.opportunityProfessionalItemId) {
            this.salesForceInfo.opportunityProfessionalItemId = '';
        }
        var reflectType = [ReflectType_1.SalesForceReflectType.OPPORTUNITY_PROFESSIONAL, ReflectType_1.SalesForceReflectType.OPPORTUNITY_ITEM_PROFESSIONAL];
        return {
            salesForceInfo: {
                torihikisakiId: this.salesForceInfo.torihikisakiId.trim(),
                professionalPrice: this.salesForceInfo.professionalPrice,
                professionalContractState: this.salesForceInfo.professionalContractState,
                professionalRequestStartDate: this.salesForceInfo.professionalRequestStartDate,
                professionalContractEdate: this.salesForceInfo.professionalContractEdate,
                professionalItPeriod: this.salesForceInfo.professionalItPeriod,
                professionalBunkatuFlg: this.salesForceInfo.professionalBunkatuFlg,
                professionalItFlg: this.salesForceInfo.professionalItFlg,
                professionalTokubetuFlg: this.salesForceInfo.professionalTokubetuFlg,
                professionalTokubetuDetail: this.salesForceInfo.professionalTokubetuDetail,
                opportunityProfessionalId: this.salesForceInfo.opportunityProfessionalId.trim(),
                opportunityProfessionalName: this.salesForceInfo.opportunityProfessionalName,
                professionalContractStartDate: this.salesForceInfo.professionalContractStartDate,
                professionalPriceBook2Id: this.salesForceInfo.professionalPriceBook2Id,
                opportunityProfessionalItemId: this.salesForceInfo.opportunityProfessionalItemId.trim(),
                professionalPriceBookMonth: this.salesForceInfo.professionalPriceBookMonth,
                professionalPriceBookData: this.salesForceInfo.professionalPriceBookData,
                professionalProductPlanName: this.salesForceInfo.professionalProductPlanName,
                professionalCancelFlag: this.salesForceInfo.professionalCancelFlag
            },
            reflectType: reflectType,
            fetchTypes: [ReflectType_1.SalesForceReflectType.OPPORTUNITY_PROFESSIONAL, ReflectType_1.SalesForceReflectType.TORIHIKISAKI]
        };
    };
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], OpportunityProfessional.prototype, "initData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], OpportunityProfessional.prototype, "initSalesForceData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({
            default: function () {
            }
        })
    ], OpportunityProfessional.prototype, "fetchSalesForceInfo", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: [] })
    ], OpportunityProfessional.prototype, "priceBookData", void 0);
    __decorate([
        vue_property_decorator_1.Watch('initData')
    ], OpportunityProfessional.prototype, "initDataChange", null);
    __decorate([
        vue_property_decorator_1.Watch('initSalesForceData')
    ], OpportunityProfessional.prototype, "initSalesForceDataChange", null);
    OpportunityProfessional = __decorate([
        vue_property_decorator_1.Component({
            components: {
                ProductSelect: ProductSelect_1.default,
                PriceBookSelect: PriceBookSelect_1.default,
                SimpleDialog: SimpleDialog_1.default,
                MoveSalesForceButton: MoveSalesForceButton_1.default,
                DatePickerWrapper: DatePickerWrapper_1.default,
                SalesForceButtonArea: SalesForceButtonArea_1.default,
                DetailDataSingleLabel: DetailDataSingleLabel_1.default
            }
        })
    ], OpportunityProfessional);
    return OpportunityProfessional;
}(vue_property_decorator_1.Vue));
exports.default = OpportunityProfessional;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sales_force/OpportunityProfessional.vue
// module id = Y+pW
// module chunks = 1